import {
    Component,
    OnInit,
    ViewContainerRef,
    ViewEncapsulation
} from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import * as _ from 'lodash';

import { Toaster, ToasterType } from './toaster';
import { ToasterService } from '../../services/toaster.service';

@Component({
    selector: 'toaster',
    templateUrl: 'toaster.component.html'
})
export class ToasterComponent implements OnInit  {
    public toasts: Toaster[] = [];

    constructor(private toasterService: ToasterService) { }

    public ngOnInit(): void {
        this.toasterService.getToaster().subscribe((toast: Toaster) => {
            if (!toast) {
                this.toasts = [];
                return;
            }

            this.toasts.push(toast);

            if (toast.toastLife) {
                setTimeout(() => {
                    this.removeAlert(toast);
                }, toast.toastLife);
            }
        });
    }

    public removeAlert(toast: Toaster): void {
        this.toasts = this.toasts.filter((x) => x !== toast);
    }

    public cssClass(toast: Toaster): string {
        if (!toast) {
            return;
        }

        switch (toast.type) {
            case ToasterType.Success:
                return ''; // css class should be here like "alert alert-success"
            case ToasterType.Error:
                return '';
            case ToasterType.Info:
                return '';
            case ToasterType.Warning:
                return '';
            default:
                return;
        }
    }

    public getTitle(toast: Toaster): string {
        if (!toast) {
            return;
        }

        if (toast.title) {
            return toast.title;
        }
    }
}
